import { GridCellParams } from '@mui/x-data-grid-pro';
import { v4 } from 'uuid';
import { GridCustomColDef } from '../../../../types';
import { DetailCTARenderer } from '../../../../Compounds/UpstackDataGrid/CellRenderers/DetailCTARenderer';
import { ComponentName, getMetaData } from '../../../../Compounds/DetailsDrawer/detailsDrawersHelpers';
import { Icon } from '../../../../Atoms/Icon';

export const rpmTableCols: GridCustomColDef[] = [
  {
    type: 'actions',
    field: 'details',
    cellClassName: 'details-cell',
    headerName: 'Details',
    sortable: false,
    hideable: false,
    width: 65,
    filterable: false,
    renderCell: (params: GridCellParams) => (
      <DetailCTARenderer
        data={params}
        value={''}
        valueFormatted={''}
        state={{
          id: v4(),
          data: params.row,
          ...getMetaData({ name: ComponentName.PRODUCT_MAP, id: params.row.id || '' })
        }}
      />
    ),
    pinned: 'left',
    disableReorder: true
  },
  {
    headerName: 'Salesforce Family Name',
    field: 'productFamily',
    flex: 3,
    sortable: true
  },
  {
    headerName: 'Salesforce Product Name',
    field: 'productName',
    flex: 3,
    sortable: true,
    renderCell: (params: GridCellParams) => (
      <a
        className="text-indigo"
        title="Open in Salesforce"
        href={`${process.env.REACT_APP_SALESFORCE_INSTANCE_URL}/lightning/r/Account/${params.row.productSfId}/view`}
        target="_blank"
        rel="noopener noreferrer">
        <div className="flex items-center text-small">
          {params.row.productName}
          <Icon type="external" />
        </div>
      </a>
    )
  },
  {
    field: 'note',
    headerName: 'Note',
    sortable: true,
    flex: 1,
    description: 'Drag to move column'
  },
  {
    field: 'productSfId',
    headerName: 'SFDC ID',
    sortable: true,
    flex: 2,
    description: 'Drag to move column'
  }
];
